/*global gsap, ScrollTrigger  */

export default {
  init() {
    // JavaScript to be fired on all pages

    /** Register ScrollTrigger Plugin */
    gsap.registerPlugin(ScrollTrigger);

    function fadeOutNDA() {
      $('#nda-tab').fadeOut();
    }

    function fadeInNDA() {
      $('#nda-tab').fadeIn();
    }

    var scrollSunTl = gsap.timeline();
    scrollSunTl.to('#nda-tab', {
      scrollTrigger: {
        trigger: '.contact',
        start: 'top bottom',
        end: 'bottom',
        markers: false,
        scrub: true,
        onEnter: () => fadeOutNDA(),
        onLeaveBack: () => fadeInNDA(),
      },
    });

    // JavaScript to be fired on all pages
    // Smooth scroll
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $('[name=" + this.hash.slice(1) + "]');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate(
              {
                scrollTop: target.offset().top - 100,
              },
              600,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    const initialSlide = $('#homepageSlider').data('initial-slide');
    const initialSlideTime = $('#homepageSlider .item:first-of-type')[0].dataset.timer;

    // Init slick slider homepage
    let slideWrapper = $('#homepageSlider').slick({
      arrows: true,
      prevArrow: $('.header-prev'),
      nextArrow: $('.header-next'),
      initialSlide: initialSlide,
      autoplaySpeed: parseInt(initialSlideTime),
      autoplay: true,
    });

    slideWrapper.on('afterChange', function (event, slick, currentSlide) {
      const video = $(`div[data-slick-index='${currentSlide}']`).find('video').get(0);
      const autoPlayTime = parseInt($('.slick-active')[0].dataset.timer);

      if (video) {
        video.play();
      }

      slideWrapper.slick('slickSetOption', 'autoplaySpeed', autoPlayTime);
    });

    slideWrapper.on('beforeChange', function (event, slick, currentSlide) {
      const video = $(`div[data-slick-index='${currentSlide}']`).find('video').get(0);
      if (video) {
        video.pause();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js